module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FORM")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Ocean like beaten metal removed from the cooling pail,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("mark of the hammer and tongs, the smith’s signage,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("grain revealed as by pressure of the burin in a Japanese print,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("substantial, bodily, color of agave, color of bitter medicine,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("translucent only when the waves rise up to break at the bar,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("fingered by sun to the texture of meringue or Verano glass.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Miami is not famous for its seashells. This beach,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("continually eroded, is held together by borrowed sand,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("graded by tractors at dawn, willed into place by the tourism industry.")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("But today, after a weeklong barrage of northeast winds,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("it resembles the famous shell beds of Sanibel,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("though these are mostly bits and pieces arrayed in sinuous drifts,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("the frilled lips and spooned-out tails of horse and queen conchs,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("sponge tubes, varieties of seaweed and uprooted coral,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("tiny broken elkhorn infants, torn fans, punch cards,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("serrated disks and tribal ornaments, teeth, dismembered ears")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("and bleached stone knuckles of a skeleton seeking restitution.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("And the eye, from its cupola of privilege, scanning the wreckage")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("to seize upon the unbroken cylinder of an olive shell,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("paired lightning whelks revolving in the wash,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("purple scallop overwritten with calcified worm tunnels—")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("how does it know to seek out only perfect forms?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6be4e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 75
// module chunks = 0